// import CognitoAuth from "@/services/CognitoAuthService";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { store } from "@/store/store";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    //ホームをホームに
    component: () => import("../components/home/Home.vue"),
    // component: () => import("../components/scan/pc/PcDownload.vue"),
    // component: () => import("../components/scan/newsinfo/newsAndFAQ.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../components/login/login.vue"),
  },
  {
    path: "/PcDownload",
    name: "PcDownload",
    component: () => import("../components/scan/pc/PcDownload.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/PcUpload",
    name: "PcUpload",
    component: () => import("../components/scan/pc/PcUpload.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/ErrorPage",
    name: "ErrorPage",
    component: () => import("../components/scan/error/ErrorPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/OnP",
    name: "onPremisesTest",
    component: () => import("../components/scan/onpremises/onPremisesTest.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/invite",
    name: "inviteUser",
    component: () => import("../components/scan/inquiryinfo/userInvite.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/UserInfo",
    name: "UserInfo",
    component: () => import("../components/scan/userinfo/UserInfo.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/newsbackno",
    name: "newsbackno",
    component: () => import("../components/scan/newsinfo/newsBackNo.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/FAQbackno",
    name: "FAQbackno",
    component: () => import("../components/scan/newsinfo/FAQBackNo.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/ManualInfo",
    name: "ManualInfo",
    component: () => import("../components/scan/inquiryinfo/manualInfo.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/InquiryInfo",
    name: "InquiryInfo",
    component: () => import("../components/scan/inquiryinfo/inquiryInfo.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/UserPermissionUpdate",
    name: "UserPermissionUpdate",
    component: () =>
      import("../components/scan/userinfo/UserPermissionUpdate.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/UserInformation",
    name: "UserInformation",
    component: () => import("../components/scan/userlist/UserInformation.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/StationCodeRegistration",
    name: "StationCodeRegistration",
    component: () =>
      import("../components/scan/admin/StationCodeRegistration.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/KDP_SalesNote",
    name: "KDP_SalesNote",
    component: () => import("../components/scan/salesnote/kdp/Top.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/KDPIssueSalesNote",
    name: "KDPIssueSalesNote",
    component: () => import("../components/scan/salesnote/kdp/IssueSalesNote.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/KDPTermsofService",
    name: "KDPTermsofService",
    component: () => import("../components/scan/salesnote/kdp/TermsofService.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/ShowPDFFileByKDPSalesNote",
    name: "ShowPDFFileByKDPSalesNote",
    component: () => import("../components/scan/salesnote/kdp/ShowPDFFileByKDPSalesNote.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/KDPConfirmationRoute",
    name: "KDPConfirmationRoute",
    component: () => import("../components/scan/salesnote/kdp/CirculationConfirmationRoute.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/KDPConfirmSalesNote",
    name: "KDPConfirmSalesNote",
    component: () => import("../components/scan/salesnote/kdp/ConfirmSalesNote.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/KDPApprovalRoute",
    name: "KDPApprovalRoute",
    component: () => import("../components/scan/salesnote/kdp/SetApprovalRouteSalesNote.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/KDPCancelSalesNote",
    name: "KDPCancelSalesNote",
    component: () => import("../components/scan/salesnote/kdp/CancelSalesNote.vue"),
    meta: { requiresAuth: true },
  },
   {
    path: "/MasterMaintenance",
    name: "MasterMaintenance",
    component: () => import("../components/scan/salesnote/kdp/MasterMaintenance.vue"),
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isAuthenticated) {
      next({
        path: "/login",
        query: {
          nextPath: to.path,
        },
      });
    } else {
      // access log append for alternative login
      if(store.state.isAltLogin == true){
        store.dispatch("setAccessLog",{mainMenuCode: to.name, accessTime: new Date()});
      }
      next();
    }
  } else {
    next();
  }
});

export default router;
